import { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "@/contexts/AuthContext"
import { LoadingState } from "./loading-state"
import { useLanguage } from "@/hooks/use-language"

interface ProtectedRouteProps {
  children: ReactNode
  requireVerification?: boolean
}

export function ProtectedRoute({ children, requireVerification = false }: ProtectedRouteProps) {
  const { user, loading } = useAuth()
  const { language } = useLanguage()

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <LoadingState message={language === "en" ? "Loading..." : "Cargando..."} />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (requireVerification && !user.emailVerified) {
    return <Navigate to="/verify-email" replace />
  }

  return <>{children}</>
}
